<div class="fixed inset-0 z-9999 flex items-center justify-center">
  <p-progressSpinner ariaLabel="loading" animationDuration=".8s" />
</div>
